export const ANNOUNCEMENTS_GET = 'ANNOUNCEMENTS_GET';